import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MpsUserService } from '../../mps/mps-auth';
import { Observable } from 'rxjs';
import {User} from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class IsAdminGuard implements CanActivate {
    constructor(
        private userService: MpsUserService,
        private router: Router
    ) { }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        
        const authUser: User = new User(this.userService.getUser().getValue());
        if (!authUser.isAdmin() && !authUser.isRH()) {
            this.router.navigate(['/']);
        }

        return true;
    }
  
}
